export default class EndPoint {
  static LOGIN = "/auth/login";
  //admin
  static LIST_PET = "/admin/get-pet-list";
  static UPDATE_PET = "/admin/update-pet";
  static UPDATE_VACCINE_HISTORY = "/admin/update-vaccine-histories";
  static DEL_PET = "/admin/delete-pets";

  static IMPORT_FILE = "/admin/import-from-excel";
}
